import React from "react"
import PropTypes from "prop-types"


const Gasto = ({gasto}) => (
    <li className="gasto">
        <p>
            {gasto.nombre}
            <span className="gasto">
                ${gasto.cantidad}
            </span>
        </p>
    </li>
)

export default Gasto

Gasto.propTypes = {
    gasto: PropTypes.object.isRequired
}